export default __webpack_public_path__ + "static/nbi-logo-47e35ae1534c201a26e124ca090b1b2b.png";